<template>
  <div>
    <page-header
      :page="page"
      :actions="pageActionConfig"
      left-side-class="col-xl-8"
      right-side-class="
        col-xl-4 align-items-end d-flex pb-2 justify-content-end
      "
    />

    <div class="rounded p-3 mb-3" style="background-color:#f2f2f2 ;">
      <div class="row rounded p-3 mx-1" style="background-color:#ffffff;">
        <div class="col-4 d-flex flex-column">
          <label class="text-muted">
            <i class="fas fa-calendar-edit text-orange mr-1"></i>
            Año Académico:
          </label>
          <span>{{ workshopDetail.academicYear?.description | empty }}</span>
        </div>
        <div class="col-4 d-flex flex-column">
          <label class="text-muted">
            <i class="fas fas fa-calendar-edit text-orange mr-1"></i>
            Fecha de Creación:
          </label>
          <span>
            {{ workshopDetail.createdDate | date }}
          </span>
        </div>
        <div class="col-4 d-flex flex-column ">
          <label class="text-muted">
            <i class="fas fa-calendar-edit text-orange mr-1"></i>
            Ultima Fecha de Modificación:
          </label>
          <span>
            {{ workshopDetail.lastUpdateDate | date }}
          </span>
        </div>
      </div>
    </div>

    <div class="mb-4">
      <q-tab :active-tab="activeTab">
        <q-tab-item
          title="Información General"
          :tabindex="tabs.GENERALINFO"
          @click="setCurrentTab(tabs.GENERALINFO)"
        >
          <validation-observer ref="generalInfo" novalidate tag="form">
            <general-info
              v-model="model.generalInformation"
              :is-read-only="isReadOnly"
            />
          </validation-observer>
        </q-tab-item>
        <q-tab-item
          title="Términos y Condiciones"
          :tabindex="tabs.TERMANDCONDITIONS"
          @click="setCurrentTab(tabs.TERMANDCONDITIONS)"
        >
          <validation-observer ref="termsAndConditions" novalidate tag="form">
            <terms-and-conditions
              v-model="model.termsAndConditions"
              :is-read-only="isReadOnly"
            />
          </validation-observer>
        </q-tab-item>
        <q-tab-item
          lazy
          title="Cuestionario"
          :tabindex="tabs.QUESTIONNAIRE"
          @click="setCurrentTab(tabs.QUESTIONNAIRE)"
        >
          <questionnaire
            ref="questionnaire"
            v-model="model.questionnaire"
            :question-types="questionnaireQuestionTypes"
            :is-read-only="isReadOnly"
          />
        </q-tab-item>
      </q-tab>
    </div>
  </div>
</template>
<script>
import {
  getWorkshopDetail,
  saveQuestionnaireConfig,
  getQuestionnaire,
  getQuestionnaireQuestionTypes,
} from '@/services/operations/dashboard-management';

import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { QTab, QTabItem } from '@/components/common/q-tabs';
import PageHeader from 'PageHeader';
import GeneralInfo from './components/general-info-tab';
import TermsAndConditions from './components/TermsAndConditionsTab';
import Questionnaire from './components/Questionnaire';
import reportService from '@/services/report';

const TABS = {
  GENERALINFO: 0,
  TERMANDCONDITIONS: 1,
  QUESTIONNAIRE: 2,
};

export default {
  name: 'ConfigureTestForm',
  components: {
    PageHeader,
    QTab,
    QTabItem,
    GeneralInfo,
    TermsAndConditions,
    Questionnaire,
  },
  mixins: [alertMixin],
  data() {
    return {
      page: {
        icon: 'fas fa-file-invoice',
        title: 'Creación de Configuración de Pruebas',
        routes: [
          'Inicio',
          'Operaciones',
          'Mantenimiento de Dashboard',
          'Creación de Configuración de Pruebas',
        ],
      },
      workshopDetail: {},
      activeTab: TABS.GENERALINFO,
      model: {
        questionnaireTypeId: null,
        generalInformation: {},
        termsAndConditions: {},
        questionnaire: {
          sections: [],
        },
      },
      questionnaireQuestionTypes: [],
    };
  },
  async mounted() {
    await this.initData();
  },
  computed: {
    isPreOrPostTest() {
      return Boolean(
        this.$route.query?.isPreOrPostTest || this.model.isPreOrPostTest
      );
    },
    postId() {
      return Number(this.$route.params.postId);
    },
    workshopId() {
      return Number(this.$route.params.workshopId);
    },
    isReadOnly() {
      return Boolean(this.$route.params.readOnly);
    },
    questionnaireTypeId() {
      const id = this.$route.params.id || this.model.questionnaireTypeId;
      return id ? Number(id) : null;
    },
    tabs() {
      return { ...TABS };
    },
    pageActionConfig() {
      return [
        {
          text: 'Regresar',
          icon: 'fas fa-arrow-circle-left',
          variant: 'outline-success',
          click: () => this.$router.go(-1),
        },
        {
          text: 'Previsualización',
          icon: 'fas fa-eye',
          variant: 'outline-success',
          visible: !!this.questionnaireTypeId,
          click: () => this.preview(),
        },
        {
          text: 'Resultado Pruebas',
          icon: 'fas fa-file-download',
          variant: 'outline-success',
          visible: !!this.questionnaireTypeId,
          click: () => this.downloadWorkshopParticipantAnswers(),
        },
        {
          text: 'Guardar',
          icon: 'fas fa-save',
          variant: 'success',
          visible: !this.isReadOnly,
          click: () => this.save(),
        },
      ];
    },
    isGeneralInfoTab() {
      return this.activeTab === TABS.GENERALINFO;
    },
    isTermsAndConditionsTab() {
      return this.activeTab === TABS.TERMANDCONDITIONS;
    },
    isQuestionnaireTab() {
      return this.activeTab === TABS.QUESTIONNAIRE;
    },
    tabValidator() {
      switch (this.activeTab) {
        case TABS.TERMANDCONDITIONS:
          return this.$refs.termsAndConditions;
        case TABS.QUESTIONNAIRE:
          return this.$refs.questionnaire;
        default:
          return this.$refs.generalInfo;
      }
    },
  },
  methods: {
    async initData() {
      this.setCurrentTab(this.activeTab);
      await Promise.all([
        this.getWorkshop(),
        this.getQuestionnaire(),
        this.getQuestionnaireQuestionTypes(),
      ]);
    },
    async getWorkshop() {
      const { data } = await getWorkshopDetail(this.workshopId);
      this.workshopDetail = data;
    },
    async getQuestionnaire() {
      if (!this.questionnaireTypeId) return;

      const { data } = await getQuestionnaire(this.questionnaireTypeId);

      this.model = {
        ...data,
        questionnaire: {
          ...data.questionnaire,
          sections: data.questionnaire.sections.map((section) => ({
            ...section,
            valid: true,
            expanded: false,
            dragging: false,
            questions: (section.questions || []).map((question) => ({
              ...question,
              valid: true,
              expanded: false,
            })),
          })),
        },
      };
    },
    async getQuestionnaireQuestionTypes() {
      if (this.questionnaireQuestionTypes.length) return;
      const { data } = await getQuestionnaireQuestionTypes();
      this.questionnaireQuestionTypes = data;
    },
    async save() {
      const titleField = this.$refs.generalInfo.$children[0].$refs.title;
      const { valid: hasTitle } = await titleField.validate();
      if (!hasTitle) {
        this.ShowToast(
          'Error',
          'Favor de completar el título del cuestionario en Información General.',
          'error'
        );
        return;
      }
      const isValid = await this.tabValidator.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar los campos requeridos.',
          'error'
        );
        return;
      }

      const confirmed = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que desea guardar?',
        'Guardar',
        'Cancelar'
      );

      if (!confirmed) return;

      const payload = {
        ...this.model,
        postId: this.postId,
        isPreOrPostTest: this.isPreOrPostTest,
        questionnaireTypeName: this.model.generalInformation?.headerTitle,
      };
      try {
        const { data: id } = await saveQuestionnaireConfig(payload);
        this.model.questionnaireTypeId = id;

        const targetRoute = {
          name: this.$route.name,
          params: {
            ...this.$route.params,
            id: id,
          },
        };

        // Solo navega si es diferente a la ruta actual
        if (this.$route.params.id !== String(id)) {
          this.$router.replace(targetRoute).catch((err) => {
            if (err.name !== 'NavigationDuplicated') throw err;
          });
        }

        this.ShowToast(
          'Éxito',
          'Se ha guardado la configuración correctamente',
          'success'
        );

        await this.getQuestionnaire();
      } catch (error) {
        this.ShowToast('Error', error?.response?.data.message, 'error');
      }
    },
    setCurrentTab(tab) {
      this.activeTab = tab;
    },
    preview() {
      if (!this.model.questionnaire?.previewUrl) return;
      const url = new URL(this.model.questionnaire.previewUrl);
      url.searchParams.set('preview', true);
      window.open(url.href, '_blank');
    },
    async downloadWorkshopParticipantAnswers() {
      await reportService.downloadWorkshopParticipantAnswers(this.postId);
    },
  },
};
</script>
